import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ConnectPlatform').create(({ theme }) => ({
  rootWrapper: {
    background: 'black',
    zIndex: 7,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'auto',
    position: 'absolute',
    bottom: 0,
    width: '100vw',
    height: '100vh',
  },

  egsRoot: {
    width: '100%',
    height: '100%',
    background: 'black',
  },

  root: {
    position: 'absolute',
    bottom: '0',
    paddingBottom: '380px',
    zIndex: 11,
  },

  rootRelative: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },

  startScreenImg: {
    position: 'absolute',
    zIndex: -1,
    filter: 'blur(20px)',
  },

  farcanaBg: {
    position: 'absolute',
    zIndex: -1,
    left: '-96px',
    width: '200%',
    top: '0px',

    filter: 'brightness(50%)',
  },

  background: {
    width: '100vw',
  },
  gabbyChopped: {
    position: 'absolute',
    right: '0px',
    zIndex: '1',
    width: '80%',
    top: '-40vh',
    maxWidth: '320px',
  },

  infoText: {
    position: 'fixed',
    zIndex: '3',
    padding: '10px 14px',
    width: '90%',
    height: '44px',
    fontSize: '14px',
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    textWrap: 'nowrap',
    top: '4vh',
    borderRadius: '12px',
    color: theme.colors.text.success,
    backgroundColor: '#14F37B1A',
    backdropFilter: 'blur(50px)',
  },

  contentWrapper: {
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
  },

  contentRoot: {
    position: 'absolute',
    bottom: '5vh',
    background: theme.colors.background.primary,
    borderRadius: '12px',
    width: '90%',
    justifySelf: 'center',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    zIndex: 5,
  },

  headerWrapper: {
    display: 'flex',
    width: '100%',
    gap: '12px',
    alignItems: 'center',

    span: {
      color: theme.colors.text.primary,
      fontSize: '22px',
    },
  },

  paragraphs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    fontWeight: 350,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.secondary,
  },

  voidInfoWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  void: {
    zIndex: '1',
    width: '45vh',
    paddingBottom: '-20vh',
  },

  tyan: {
    position: 'absolute',
    zIndex: '1',
    width: '80%',
    top: '-70%',
    maxWidth: '300px',
    paddingTop: '100px',
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  connectButton: {
    height: '52px',

    span: {
      fontSize: theme.sizes.texts.fontSize.m,
      fontWeight: 460,
    },
  },

  whatData: {
    color: theme.colors.text.link,
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  noSteamButton: {
    background: 'transparent',
    width: '100%',
    height: '52px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'none !important',

    fontSize: '13px',
    textTransform: 'uppercase',
    fontWeight: 370,
    color: theme.colors.text.secondary,
  },
}))
